import Hero from "../components/sections/Hero";
import About from "../components/sections/About";
import Services from "../components/sections/Services";
import Portfolio from "../components/sections/Portfolio";
import TechStack from "../components/sections/TechStack";
import Process from "../components/sections/Process";
import Testimonials from "../components/sections/Testimonials";
import Careers from "../components/sections/Careers";
import Contact from "../components/sections/Contact";
import useSEO from "../lib/useSEO";

export default function HomePage() {
    useSEO({
        title: "Thooyra Technologies — Custom ERP, SaaS, Mobile & Cloud Software Development in Chennai",
        description:
            "Chennai-based software development company building custom ERP systems, accounting software, SaaS platforms, mobile apps, cloud solutions and business automation for growing companies.",
        path: "/",
    });
    return (
        <main data-testid="home-page">
            <Hero />
            <About />
            <Services compact />
            <Portfolio />
            <TechStack />
            <Process />
            <Testimonials />
            <Careers />
            <Contact />
        </main>
    );
}
